module.exports = __webpack_public_path__ + "f34ec9dd9ccad78c561be723a56bc452.svg";